// extracted by mini-css-extract-plugin
export default {"root":"style_root__S-2Gl","label":"style_label__yJEId","hint":"style_hint__XJfPP","row":"style_row__tOIZ6","link":"style_link__+Gi8+","mailto":"style_mailto__8Mbep"};